module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-switch/es/index.js
// module id = 1564
// module chunks = 0